import React from "react";
import { useIntl } from "react-intl";
import classnames from "classnames";

import messages from "./TableOfContents.messages";
import "./TableOfContents.scss";

const TableOfContents = ({ tocElements, activeIndex }) => {
    const { formatMessage } = useIntl();
    return (
        <div className="sidebar-toc">
            <h3 className="sidebar-toc__title">
                {formatMessage(messages.tableOfContentsTitle)}
            </h3>
            <ol className="sidebar-toc__list">
                {tocElements.map(({ anchor, content }, i) => (
                    <li
                        key={anchor}
                        className={classnames("sidebar-toc__list__item", {
                            "is-active": i === activeIndex,
                        })}
                    >
                        <a
                            href={`#${encodeURIComponent(anchor)}`}
                            data-testid={i === 0 ? "sidebar-link" : undefined}
                        >
                            {content}
                        </a>
                    </li>
                ))}
            </ol>
        </div>
    );
};

export default TableOfContents;
